import {
    FORM_LIST_REQUEST,
    FORM_LIST_SUCCESS,
    FORM_LIST_FAIL,
    FORM_LIST_RESET,
    FORM_DETAILS_REQUEST,
    FORM_DETAILS_SUCCESS,
    FORM_DETAILS_FAIL,
    FORM_DETAILS_RESET,
    FORM_CREATE_REQUEST,
    FORM_CREATE_SUCCESS,
    FORM_CREATE_FAIL,
    FORM_CREATE_RESET,
    FORM_UPDATE_REQUEST,
    FORM_UPDATE_SUCCESS,
    FORM_UPDATE_FAIL,
    FORM_UPDATE_RESET,
    FORM_DELETE_REQUEST,
    FORM_DELETE_SUCCESS,
    FORM_DELETE_FAIL,
    FORM_DTO_REQUEST,
    FORM_DTO_SUCCESS,
    FORM_DTO_FAIL,
    FORM_DTO_RESET,
    FORM_LIST_BYIDS_REQUEST,
    FORM_LIST_BYIDS_SUCCESS,
    FORM_LIST_BYIDS_FAIL,
    FORM_LIST_BYIDS_RESET
} from '../constants/formConstants';

export const formListReducer = (
    state = {
        forms: []
    }, action) => {
    switch (action.type) {
        case FORM_LIST_REQUEST:
            return { loading: true, forms: [] };
        case FORM_LIST_SUCCESS:
            return {
                loading: false,
                forms: action.payload.items,
                totalPages: action.payload.totalPages,
                currentPage: action.payload.currentPage,
                totalCount: action.payload.totalCount,
            };
        case FORM_LIST_FAIL:
            return { loading: false, error: action.payload, forms: [] };
        case FORM_LIST_RESET:
            return { forms: [] };
        default:
            return state;
    }
};

export const formDetailsReducer = (
    state = {
        form: {}
    }, action) => {
    switch (action.type) {
        case FORM_DETAILS_REQUEST:
            return { loading: true, form: {} };
        case FORM_DETAILS_SUCCESS:
            return { loading: false, form: action.payload };
        case FORM_DETAILS_FAIL:
            return { loading: false, error: action.payload, form: {} };
        case FORM_DETAILS_RESET:
            return { form: {} };
        default:
            return state;
    }
};


export const formCreateReducer = (state = {}, action) => {
    switch (action.type) {
        case FORM_CREATE_REQUEST:
            return { loading: true }
        case FORM_CREATE_SUCCESS:
            return { loading: false, success: true, form: action.payload }
        case FORM_CREATE_FAIL:
            return { loading: false, error: action.payload }
        case FORM_CREATE_RESET:
            return {}
        default:
            return state
    }
};

export const formUpdateReducer = (state = {} , action) => {
    switch (action.type) {
        case FORM_UPDATE_REQUEST:
            return { loading: true }
        case FORM_UPDATE_SUCCESS:
            return { loading: false, success: true, form: action.payload }
        case FORM_UPDATE_FAIL:
            return { loading: false, error: action.payload }
        case FORM_UPDATE_RESET:
            return { form: {} }
        default:
            return state
    }
};

export const formDeleteReducer = (state = {}, action) => {
    switch (action.type) {
        case FORM_DELETE_REQUEST:
            return { loading: true }
        case FORM_DELETE_SUCCESS:
            return { loading: false, success: true }
        case FORM_DELETE_FAIL:
            return { loading: false, error: action.payload }
        default:
            return state
    }
};

export const formDtoReducer = (state = { formDto: {} }, action) => {
    switch (action.type) {
        case FORM_DTO_REQUEST:
            return { loading: true, formDto: {} };
        case FORM_DTO_SUCCESS:
            return { loading: false, formDto: action.payload };
        case FORM_DTO_FAIL:
            return { loading: false, error: action.payload, formDto: {} };
        case FORM_DTO_RESET:
            return { formDto: {} };
        default:
            return state;
    }
};

export const formListByIdsReducer = (
    state = {
        loading: false,
        forms: [],
        error: null
    }, action) => {
    switch (action.type) {
        case FORM_LIST_BYIDS_REQUEST:
            return { loading: true, forms: [], error: null };
        case FORM_LIST_BYIDS_SUCCESS:
            return { loading: false, forms: action.payload, error: null };
        case FORM_LIST_BYIDS_FAIL:
            return { loading: false, error: action.payload, forms: [] };
        case FORM_LIST_BYIDS_RESET:
            return { loading: false, forms: [], error: null };
        default:
            return state;
    }
};

